import React from 'react';
import { useTranslation } from 'react-i18next';
import { Title, MainText } from './../../helpers/Typography';

const TermsOfUse = () => {
    const { t } = useTranslation();

    return (
        <div className="container mx-auto pt-12">
            <Title>{t('routes.termsOfUse')}</Title>
            <MainText>{t('termsOfUse.main')}</MainText>
            <ol className="list-decimal list-inside px-4 lg:px-2 xl:px-0 mb-4 lg:mb-8 xl:mb-16 text-sm md:text-base text-gray-800 leading-loose tracking-wide">
                {t('termsOfUse.rules', { returnObjects: true }).map((rule, index) => (
                    <li key={index}>
                        <span className="font-mardoto-bold">{rule.title}</span>
                        <ul className="text-sm list-disc list-inside mb-8 font-mardato">
                            {rule.content.map((contentItem, idx) => (
                                <li key={idx}>{contentItem}</li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ol>
        </div>
    );
};

export default TermsOfUse;
